import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import { IColInfo, IHeaderButtonInfo, IRowButtonInfo } from '../../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import ItemRevisionModel from '../../../models/ItemRevisionModel';
import DataService from "../../../services/data.service";
import ItemRevision_popup_CreateNewItemRevision from '../Popups/ItemRevision_popup_CreateNewItemRevision';

interface IProps {
    itemRevision: ItemRevisionModel,
    refreshNr: number
}

const ItemRevision_tab_Revisions: React.FC<IProps> = ({ itemRevision, refreshNr }) => {
    const [data, setData] = useState<ItemRevisionModel[]>();
    const [showPopup, setShowPopup] = useState<boolean>(false)
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedForItemType } = useAuth();
    const navigate = useNavigate()

    useEffect(() => {
        getTableData();
    }, [itemRevision.id, refreshNr]);

    function getTableData() {
        DataService.get<ItemRevisionModel[]>('api/v1/ItemRevisions/ByItem/' + itemRevision.itemId)
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function showBOM(rowData: ItemRevisionModel) {
        if (rowData.defaultBomId)
            navigate('/plm/items/billofmaterials/' + rowData.defaultBomId)
    }

    function hasBOM(rowData: ItemRevisionModel) {
        return rowData.hasBom;
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/ItemRevisions/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }


    const colInfos: IColInfo[] = [
        { key: true, dataProp: 'id', visible: false },
        { title: 'Version', dataProp: 'revisionNumber', sort: 'desc' },
        { title: 'Status', dataProp: 'itemStatus.name', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Active from', dataProp: 'beginDate', dataType: 'date' },
        { title: 'until', dataProp: 'endDate', dataType: 'date' },
        { title: 'Checked out', dataProp: 'checkedOutOn', dataType: 'datetime' },
        { title: 'Checked out by', dataProp: 'checkedOutByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
        { title: 'Created on', dataProp: 'createdOn', dataType: 'datetime' },
        { title: 'Created by', dataProp: 'createdByUser', dataType: 'user', filterInfo: { filterType: 'CheckboxList' } },
    ];

    if (isAuthorizedForItemType(ApplicationFunctions.ViewBillOfMaterial, itemRevision.item.itemTypeId))
        colInfos.push(
            {
                width: 110,
                sort: false,
                dataProp: 'BOM-button',
                rowButtons: [{ text: "BOM", onClick: showBOM, isVisible: hasBOM }],
            });


    if (isAuthorizedForItemType(ApplicationFunctions.CreateItemRevision, itemRevision.item.itemTypeId) || isAuthorizedForItemType(ApplicationFunctions.DeleteItemRevision, itemRevision.item.itemTypeId)) {
        let headerButtons: IHeaderButtonInfo[] = [];
        if (isAuthorizedForItemType(ApplicationFunctions.CreateItemRevision, itemRevision.item.itemTypeId))
            headerButtons = [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: () => setShowPopup(true) }];

        let rowButtons: IRowButtonInfo[] = [];
        if (isAuthorizedForItemType(ApplicationFunctions.CreateItemRevision, itemRevision.item.itemTypeId))
            rowButtons = [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }];

        colInfos.push(
            {
                headerButtons: headerButtons,
                rowButtons: rowButtons,
            });
    }

    return (
        <>
            <DataTable
                name='dtItemItemRevisions'
                colInfos={colInfos}
                tableData={data}
                navigateTitle='Itemrevision'
                navigateUrl='/plm/Items/ItemRevision/'
            />
            {showPopup && <ItemRevision_popup_CreateNewItemRevision itemRevision={itemRevision} show={showPopup} onHide={(newItemRevisionId) => { getTableData(); setShowPopup(false); }} />}
        </>
    );
}
export default ItemRevision_tab_Revisions;